import React from 'react';
import { useTranslation } from 'react-i18next';
import cx from 'classnames';

import { Package } from 'types/interfaces/Package';

import styles from './legal.module.sass';

type PropTypes = {
  pack: Package;
  className?: string;
};

export const Legal: React.FC<PropTypes> = ({ pack, className }) => {
  const { t } = useTranslation('app');

  return (
    <p className={cx(styles.legalText, className)}>
      {t('buySticker.legal', {
        currency: pack.currency,
        price: pack.initial_price_full,
      })}
    </p>
  );
};
